import script from "./CustomAccordion.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomAccordion.vue?vue&type=script&lang=ts&setup=true"

import "./CustomAccordion.vue?vue&type=style&index=0&id=4bc8803e&scoped=true&lang=css"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bc8803e"]])

export default __exports__